import React, { useState } from 'react'
import classes from "./styles/faq.module.css";
import minus from "./dumble.png";
import plus from "./dumble.png";

const Faq2 = () => {
    const [box1 , setBox1] = useState(false);
    const [box2 , setBox2] = useState(false);
    const [box3 , setBox3] = useState(false);

    const handlebox1 = () => {
        setBox1(!box1);
    }
    const handlebox2 = () => {
        setBox2(!box2);
    }

    const handlebox3 = () => {
        setBox3(!box3);
    }
    // const handlebox4 = () => {
    //     setBox4(!box4);
    // }

  return (
    <div className={classes.Container}>
      <div className={box1 ? classes.boxOpen : classes.box} onClick={handlebox1}>
            <div className={classes.upperCon}>
                <div>Do I need any equipment?</div>
                <div className={`${classes.logoCon} ${box1 ? classes.rotateIcon : ''}`}><img src={box1 ? minus : plus} alt='plus-minus-icon'/></div>
            </div>
            <div className={classes.lowerCon}>
                <div>Minimal equipment is needed. You can train with just <b>body weight, resistance bands, or dumbbells</b> —we customize
                based on what you have.</div>
            </div>
        </div>


        <div className={box2 ? classes.boxOpen : classes.box} onClick={handlebox2}>
            <div className={classes.upperCon}>
                <div>How do I join live sessions?</div>
                <div className={`${classes.logoCon} ${box2 ? classes.rotateIcon : ''}`}><img src={box2 ? minus : plus} alt='plus-minus-icon'/></div>
            </div>
            <div className={classes.lowerCon}>
                <div>You’ll receive a <b>link before each session</b> and a <b>WhatsApp reminder</b> an hour before so you never miss your workouts.</div>
            </div>
        </div>



        <div className={box3 ? classes.boxOpen : classes.box} onClick={handlebox3}>
            <div className={classes.upperCon}>
                <div>What if I have no time for workouts?</div>
                <div className={`${classes.logoCon} ${box3 ? classes.rotateIcon : ''}`}><img src={box3 ? minus : plus} alt='plus-minus-icon'/></div>
            </div>
            <div className={classes.lowerCon}>
                <div>We offer a <b>nutrition-only approach</b> where you can lose weight without workouts. You just need to <b>walk for 30 mins
                daily</b> while listening to music or podcasts.</div>
            </div>
        </div>

        {/* <div className={box4 ? classes.boxOpen : classes.box} onClick={handlebox4}>
            <div className={classes.upperCon}>
                <div>What if I miss a workout or have a busy week?</div>
                <div className={`${classes.logoCon} ${box4 ? classes.rotateIcon : ''}`}><img src={box4 ? minus : plus} alt='plus-minus-icon'/></div>
            </div>
            <div className={classes.lowerCon}>
                <div>Life happens! The program is flexible, and you’ll receive guidance on how to stay on track even during busy times.</div>
            </div>
        </div> */}
    </div>
  )
}

export default Faq2;
